import React, { useEffect, useState } from 'react';
import config from "../../config/config";
import axios from "axios";
import { getAuthToken } from "../../utils/token";
import { Modal, Button, Row, Col, Form } from 'react-bootstrap';
const InspectionReportModal = ({ show, handleClose, qualityId }) => {
  const [qualitycheckhistory, setQualitycheckhistory] = useState({});
  const fetchQualitycheckhistory = async () => {
    const token = getAuthToken();
    if (!token || !qualityId) return;
    try {
      const response = await axios.get(
        `${config.API}/supervisor/qualitycheckhistory/${qualityId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response?.data?.success) {
        setQualitycheckhistory(response.data.quality_issues || {});
      } else {
        setQualitycheckhistory({});
      }
    } catch (err) {
      console.error("Error fetching Inspection Report:", err);
      setQualitycheckhistory({});
    }
  };
  useEffect(() => {
    if (show) {
      fetchQualitycheckhistory();
    }
  }, [qualityId, show]);

  return (
    <Modal show={show} onHide={handleClose} centered size="lg" className="font_family">
      <Modal.Body className="p-5">
        <strong className="fs-4">Inspection Report</strong>
        <div className="p-3 mb-4 bg-light mt-4">
          <h6>Product Information</h6>
          <Row>
            <Col>
              ID: <strong>{qualitycheckhistory?.product?.product_code || ""}</strong>
            </Col>
            <Col>
              Product: <strong>{qualitycheckhistory?.product?.name || ""}</strong>
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              Expected Qty: <strong>{qualitycheckhistory?.quantity_to_be_tested || 0}</strong>
            </Col>
          </Row>
        </div>
        <Row className="mb-3">
          <Col md={4}>
            <Form.Label><strong>Actual Quantity</strong></Form.Label>
          </Col>
          <Col md={8}>
            <div className="d-flex align-items-center">
              <Form.Control
                type="number"
                value={qualitycheckhistory?.quantity_tested || ""}
                readOnly
              />
            </div>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <Form.Label><strong>Quantity of NC</strong></Form.Label>
          </Col>
          <Col md={8}>
            <div className="d-flex align-items-center">
              <Form.Control
                type="number"
                value={
                  qualitycheckhistory
                    ? qualitycheckhistory.quantity_tested - qualitycheckhistory.quantity_passed
                    : ""
                }
                readOnly
              />
            </div>
          </Col>
        </Row>
        <Row className="mt-5">
          <Col md={3}>
            <Form.Label><strong>Notes</strong></Form.Label>
          </Col>
          <Col md={9}>
            <Form.Control
              as="textarea"
              rows={3}
              value={qualitycheckhistory?.notes || ""}
              readOnly
            />
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer className="border-0 mb-3">
        <Button variant="secondary" onClick={handleClose}>Close</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default InspectionReportModal;
